<template>
    <div>
        <a-card 
        size="small" 
        title="基本信息" 
        :headStyle='{
            background : "#f3f3f3"
        }'
        >
            <template v-slot:extra>
                <a-button @click='backPage'>返回</a-button>


            </template> 
            <a-row class='title_row'>
                <a-col :span="12">
                    <span class='clb'>退款订单号：</span>
                    {{detail.returnOrderCode}}
                    <a-button type="primary" style='margin-left:10px' @click='associated'>
                        关联单
                       
                    </a-button>
                    <a-button type="primary" style='margin-left:10px' @click='toSupply'>
                        供应单
                       
                    </a-button>
                </a-col>
                <a-col :span="12" style='color:red'>
                        <span class='clb'>状态：</span>
   
                        {{detail.refundStateVal}}
                
                </a-col>
            </a-row>

            <a-row class='title_row'>
                <a-col :span="12" style='color:#999!important'>
                    <span class='clb' style='color:#999!important'>原始订单号：</span>
                    {{detail.orderCode}}
                   
                </a-col>
             
            </a-row>

            <a-row style='margin-top:20px'>
                <a-col :span="6">
                    <span class='clb'>退票时间：</span>
                    {{detail.createTime}}
                    
                </a-col>
            


                 <!-- <a-col :span="6">
                    <span class='clb'>支付状态：</span>
                    {{detail.payStateValue}}
                    

                </a-col> -->
                <!-- <a-col :span="6">
                    <span class='clb'>出票供应：</span>
                    暂无
                
                </a-col>
                <a-col :span="6">
                    <span class='clb'>供应单号：</span>
                    暂无
                
                </a-col> -->
            </a-row>
            <a-row style='margin-top:20px'>
                <a-col :span="6">
                    <span class='clb'>备注：</span>
                    {{detail.remark}}
                    
                </a-col>
               
            </a-row>

        </a-card>

        <a-card 
        size="small" 
        title="车票详情"
        style='margin-top:20px'
        :headStyle='{
            background : "#f3f3f3"
        }'
        >

          <template v-slot:extra>
            <a-button @click="refundSuccess">
              {{handleState.stateValueSuccess}}
            </a-button>
            <a-button style="margin-left: 20px;"  @click="refundFail">
              {{handleState.stateValueFail}}
            </a-button>

            <a-button style="margin-left: 20px;"  @click="refundFlow">
              处理退款
            </a-button>

          </template>



          <a-row>
                <a-col :span="12" class='ticket'>
                    <div>
                        {{detail.orderSearchBo.fromStation}}
                        <div class='time_div'>{{detail.orderSearchBo.fromTimeFormat}}</div>
                    </div>
                    <div class='line_content'>
                        <span>耗时{{detail.orderSearchBo.takeTimeFormat}}</span>
                        <span class='line'></span>
                    </div>
                    <div>
                        {{detail.orderSearchBo.toStation}}（<span style='color:red'>{{detail.orderSearchBo.trainNo}}</span>）
                        <div class='time_div'>{{detail.orderSearchBo.toTimeFormat}}</div>
                    </div>
                </a-col>
            </a-row>

            <a-table :columns="columns" bordered v-show='refresh'
                :data-source="detail.orderSearchBo.passengersList" 
                :pagination='false' 
                
                :row-key="r => r.id"
                :loading='loading'
                style='margin-top:20px'
                >

              <template v-for="col in ['refundServiceAmount','refundAmount']" #[col]="{ text, record }" :key="col">
                <div>
                  <a-input
                      v-if="editableData[record.id]"
                      v-model:value="editableData[record.id][col]"
                      style="margin: -5px 0"
                  />
                  <template v-else>
                    {{ text }}
                  </template>
                </div>
              </template>


                <template v-slot:type="{ text,record }">
                    {{record.passengerTypeValue}}
                </template>

                <template v-slot:lastCoach="{ text,record }">
                    {{record.lastCoach}}/{{record.lastSeat}}
                </template>
                <!-- <template v-slot:customTitle="{text,record}"> -->
                    <template #customTitle>
                    <span ref='myRef'>
                        <!-- {{record.ticketState==90?'退票失败原因':''}} -->
                        退票失败原因
                       <!-- {{compare}} -->
                    </span>
                </template>
                <template v-slot:refundState='{text,record}'>
                    {{record.ticketState?record.ticketState:''}}
                    <!-- {{record.ticketState==90?record.remark:'111'}} -->
                </template>
            </a-table>

        </a-card>
    

        <df-orderLog :list='operationLogList'></df-orderLog>


        <a-modal v-model:visible="modalVisible" title="关联订单" :footer="null">
            <a-list
                item-layout="horizontal"
                :data-source="associateddata"
                class='a_list'
            >
                <template v-slot:renderItem="{ item, index }">
                    <a-list-item>
                        <div class='flex-row'>   
                            <div>{{associateValue[item.orderType]}}：<span style='color:#1890ff;cursor:pointer' @click='toRefoundDetail(item)'>{{item.orderCode}}</span></div>
                            <div>{{item.amount}}</div>
                        </div>

                         <div class='flex-row'>   
                            <div style='color:red'>{{item.stateValue}}</div>
                            <div>{{item.operationTime}}</div>
                        </div>
                        
                    </a-list-item>

                </template>

            </a-list>
          
        </a-modal>


      <!-- 退票失败原因 -->
      <a-modal v-model:visible="createVisible" width="450px" @ok="failReason" title="请输入退票失败原因">
        <a-spin :spinning="createSpinning">
          <a-input
              v-model:value="failReasonInput.remark"
              placeholder="失败原因"
              allowClear
          />
        </a-spin>
      </a-modal>
        
    </div>
</template>

<script>
  import shopApi from '@axios/shop'
  import moment from 'moment';
  import { reactive, ref ,onMounted,computed,watch,nextTick} from 'vue'
  import { useRoute, useRouter } from 'vue-router'
  import orderApi from '@axios/order'
  import orderState  from '@assets/static';
  import { message } from 'ant-design-vue';
  export default {
    name: 'orderDetail',
    components: {
    },
    setup(){
        let refresh=ref(false)
        // const myRef = ref(null);
        // onMounted(()=>{
        //     if(ticketState.value!==90){
        //         myRef.value.parentNode.parentNode.parentNode.parentNode.style.display='none'
        //     }
        // })
        // let compare=computed(()=>{
        //   return ticketState==90?'退票失败原因':''
        // })
        let myRef=ref(null)
   let  columns= ref( [
                 {
                    title: '票号',
                    dataIndex: 'ticketNo',
                    width: 100,
                    align : 'center',
                },
                {
                    title: '乘客',
                    dataIndex: 'passengerName',
                    width: 100,
                    align : 'center',
                
                },
                {
                    title: '车票类型',
                    dataIndex: 'mobile',
                    width: 100,
                    align : 'center',
                    slots: { customRender: 'type' },
                
                },
                {
                    title: '座位',
                    dataIndex: 'lastCoach',
                    width: 100,
                    align : 'center',
                    slots: { customRender: 'lastCoach' },
                },
                {
                    title: '检票口',
                    dataIndex: 'ticketCheck',
                    width: 100,
                    align : 'center',
                },
                {
                    title: '手机号',
                    dataIndex: 'mobile',
                    width: 150,
                    align : 'center',
                },
                {
                    title: '证件类型',
                    dataIndex: 'cardTypeValue',
                    width: 100,
                    align : 'center',
                },
                {
                    title: '证件号',
                    dataIndex: 'cardNo',
                    width: 200,
                    align : 'center',
                },
               {
                 title: '退款',
                 dataIndex: 'refundAmount',
                 width: 70,
                 align : 'center',
                 slots: { customRender: "refundAmount" }
               },
               {
                 title: '退票手续费',
                 dataIndex: 'refundServiceAmount',
                 width: 70,
                 align : 'center',
                 slots: { customRender: "refundServiceAmount" }
               },
                {
                    title: '采购价',
                    dataIndex: 'ticketLastPrice',
                    width: 70,
                    align : 'center',
                },
                {
                    title: '票价',
                    dataIndex: 'ticketSalePrice',
                    width: 70,
                    align : 'center',
                },
                {
                    width:100,
                    align:'center',
                    slots:{
                        title:'customTitle',
                        customRender:'refundState'
                },
                }
            ],)
        let ticketState=ref('')
        watch(ticketState,(pre,next)=>{
            if(ticketState.value!==90){
                    columns.value.pop()
            }
            refresh.value=true
        })
        let newRefund=ref('')
        let loading = ref(false);
        const router = useRouter()
        let list = ref([]);
        const route = useRoute();
        const code = route.query.code;
        let detail = ref({
            orderSearchBo : {}
        });
        let modalVisible = ref(false);  
        
        let operationLogList = ref([])
        const getDetail = (code) => {
            orderApi.refund(code).then((res)=>{
                ticketState.value=res.refundState
               newRefund.value=res.refundTicketBos[0].remark
                detail.value = res;
                operationLogList.value = res.operationLogBos;
                detail.value.orderSearchBo.passengersList[0].ticketState=ticketState.value
                detail.value.orderSearchBo.passengersList[0].ticketState= newRefund.value
              editableSetUp(res);
              refundOrderStateBtn(res);
            })
        }   
    
        let associateValue = {
            10 : '普通订单',
            20 : '改签订单',
            30 : '退票订单'
        }

        getDetail(code);    

        let associateddata = ref([]);

        const associated = () =>{
            let params = {
               orderCode : detail.value.orderCode
            }
            orderApi.associated(params).then((res) => {

                if(res.length){
                    modalVisible.value = true;
                    associateddata.value = res;
                }else{
                    message.error('未查询到关联单')
                }
            })
        }

        const toRefoundDetail = (item) =>{
            
            let name = 'orderDetail'
            if(item.orderType == 30){
                name = 'refundDetailIndex'
            }
            const newweb = router.resolve({name: name, query: {
                code : item.orderCode
            }})
            window.open(newweb.href,'_blank')
        }


        const toSupply = (code) =>{
            const newweb = router.resolve({name: 'supplyDetailIndex', query: {
                code : detail.value.orderCode,

            }})
            window.open(newweb.href,'_blank')
        }
        const backPage = () => {
            router.back();
        }

      const editableData = reactive({});

      let handleState = ref({});

      const editableSetUp = (res) => {
        res.orderSearchBo.passengersList.forEach(item =>{
          editableData[item.id] = item
        })
      }

      //当前订单详情状态
      let refundOrderStateEnum = {
        created:10,
        refunding:20,
        refundedPart:30,
        refunded:40,
        refundFail:90
      };

      const refundOrderStateBtn = (res) => {
        if (res.state === refundOrderStateEnum.refunding || res.refundState === refundOrderStateEnum.refunding){
          handleState.value.stateValueSuccess = '退票成功'
          handleState.value.stateValueFail = '退票失败'
        }else {
          handleState.value.stateValueSuccess = '无需处理'
          handleState.value.stateValueFail = '无需处理'
        }
      }

      const refundSuccess = () => {
        console.log("refundSuccess{}",detail.value)

        if (handleState.value.stateValueSuccess === '无需处理'){
          message.success("当前状态无需处理")
          return
        }
        let param = detail.value;
        param.state = refundOrderStateEnum.refunded

        orderApi.handleRefundOrders(param).then((detail)=>{
          message.success("处理退票成功")
          getDetail(code);
        })
        getDetail(code);
      }
      const refundFail = () => {
        showFailReasonInput();

      }

      const refundFlow = () => {
        let param = detail.value;
        param.ticketMode = 'refundFlow'

        if (param.orderSearchBo.ticketMode !== 3){
          message.success("只允许电子票进行退款")
          return
        }
        orderApi.handleRefundOrders(param).then((detail)=>{
          message.success("处理电子票退款推送完成")
          getDetail(code);
        })
        getDetail(code);
      }

      let failReasonInput = ref({
        remark:""
      });



      //退票失败原因
      let createVisible = ref(false);
      //退票失败完毕
      let createSpinning = ref(false);
      const failReason = () => {

        let param = detail.value;
        param.remark = failReasonInput.value.remark
        if (handleState.value.stateValueFail === '无需处理'){
          message.success("当前状态无需处理")
          return
        }
        createVisible.value = false;
        createSpinning.value = false;

        param.state = refundOrderStateEnum.refundFail
        orderApi.handleRefundOrders(param).then((detail)=>{
          message.success("处理退票失败完成")
          getDetail(code);
        })
        getDetail(code);

      }
      const showFailReasonInput = () => {
        createVisible.value = true;
      };
      const createCancel = () => {
        createVisible.value = false;
        createSpinning.value = false;
      };

        return {
          failReasonInput,
          createCancel,
          failReason,
          showFailReasonInput,
          createSpinning,
          createVisible,
          handleState,
          refundOrderStateBtn,
          refundFlow,
          refundFail,
          refundSuccess,
          editableData,
            refresh,
            myRef,
            columns,
            newRefund,
            ticketState,
            associateValue,
            operationLogList,
            backPage,
            toSupply,
            toRefoundDetail,
            associateddata,
            associated,
            modalVisible,
            orderState,
            activeKey : ['1'],
            loading,
            detail,
            list,
           
        }
    }
  }
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .a_list /deep/  .ant-list-item{
        display: block!important;
        background: #eee!important;
        padding: 10px 10px;
        border-radius:3px ;
        margin-bottom: 20px;
    }
    .log_content{
        margin-top:20px;
   
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    }
    .log_content /deep/ .ant-collapse-content-box{
        padding-bottom: 0!important;
    }

    .log_content /deep/ .ant-timeline-item-content{
        min-height:auto!important ;
    }
    .log_content /deep/ .ant-card-body{
        padding-top:30px;
        padding-bottom:10px;
    }
    .clb{
        color:#000;
    }
    .title_row{
        line-height: 40px;
        font-size: 20px;
    }
    .ticket{
        display: flex;
        justify-content: flex-start;
        div{
            margin-right: 30px;
           
            font-size: 20px;
            color:#000;
            font-weight: bold;
        }
        .line_content{
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            line-height: 20px!important;
            text-align: center;
            font-size: 16px;
            position: relative;
            top:-10px;
        
            .line{
                margin-top: 5px;
                width: 150px;
                height: 1px;
                background: rgba(0, 0, 0, 0.65);
            }
        }
    }
    .ticket_time{
        padding-right: 10px;
        line-height: 30px;
        display: flex;
        justify-content: flex-start;
        align-items: right;
        flex-direction: column;
    }
    .time_div{
      
        font-weight: normal;
    }
    .flex-row{
        width: 100%;
        display:flex;
        justify-content: space-between!important;
    }
  
</style>
